import { render, staticRenderFns } from "./ScientificProductionReport.vue?vue&type=template&id=977fd08a&"
import script from "./ScientificProductionReport.vue?vue&type=script&lang=js&"
export * from "./ScientificProductionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports